/* eslint-disable prettier/prettier */
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import LoadingProgress from 'common/components/progress/loading';
import Table6 from 'common/components/table/table6';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import getUserIndividualAnswers from './userAnswersActions';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import { BASE_S3 } from 'config/consts';

function ActionOffers(props) {
  useEffect(() => {
    if (props.userId && props.actionId) {
      props.getUserIndividualAnswers(props.userId, props.actionId);
    }
  }, []);

  if (props.userAnswers.loading) {
    return (
      <div className="d-flex justify-content-center mt-5">
        <LoadingProgress />
      </div>
    );
  }
  return (
    <section>
      {props.userAnswers.list.map((item, index) => (
        <Box style={{ margin: 20 }} key={index}>
          <Typography style={{ marginBottom: 20 }} variant="h6">
            {item.question}
          </Typography>
          {item.type_id === 1 ? (
            <>
              <Table6
                columns={[{ field: 'question_option.label', title: 'Resposta' }]}
                data={item.Answers}
              />
            </>
          ) : item.type_id === 2 ? (
            <>
              <Table6
                columns={[{ field: 'question_option.label', title: 'Respostas' }]}
                data={item.Answers}
              />
            </>
          ) : item.type_id === 3 ? (
            <>
              <Table6 columns={[{ field: 'answer', title: 'Respostas' }]} data={item.Answers} />
            </>
          ) : item.type_id === 4 ? (
            <>
              <Table6
                columns={[
                  {
                    field: 'question_option.label',
                    title: 'Resposta',
                    render: (rowData) =>
                      rowData.answer
                        ? `(Outros) ${rowData.answer}`
                        : rowData.question_option?.label,
                  },
                ]}
                data={item.Answers}
              />
            </>
          ) : item.type_id === 5 ? (
            <>
              <Table6
                columns={[
                  {
                    field: 'question_option.label',
                    title: 'Respostas',
                    render: (rowData) =>
                      rowData.answer
                        ? `(Outros) ${rowData.answer}`
                        : rowData.question_option?.label,
                  },
                ]}
                data={item.Answers}
              />
            </>
          ) : (
            <>
              <Table6
                columns={[{
                  field: 'question_option.label',
                  title: 'Respostas',
                  render: (rowData) => {
                    const { file, answer, question_option } = rowData;

                    // Se não houver arquivo, mantém seu fallback de texto/outros
                    if (!file?.path || !file?.saved_name) {
                      if (answer) return `(Outros) ${answer}`;
                      return question_option?.label;
                    }

                    const url = `${BASE_S3}/${file.path}/${file.saved_name}`;
                    const ext = file.saved_name.split('.').pop().toLowerCase();

                    // IMAGEM
                    if (/^(jpe?g|png|gif|bmp|webp|svg)$/.test(ext)) {
                      return (
                        <a href={url} target="_blank" rel="noopener noreferrer">
                          <img
                            src={url}
                            alt={file.saved_name}
                            style={{ maxWidth: 300, maxHeight: 300, objectFit: 'contain' }}
                          />
                        </a>
                      );
                    }

                    // PDF
                    if (ext === 'pdf') {
                      return (
                        <a
                          href={url}
                          download
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            textDecoration: 'none',
                          }}
                        >
                          <InsertDriveFileIcon style={{ marginRight: 4 }} />
                          {file.saved_name}
                        </a>
                      );
                    }

                    // DOCX via Google Viewer
                    if (ext === 'docx') {
                      const gViewerUrl =
                        'https://docs.google.com/gview?url=' +
                        encodeURIComponent(url) +
                        '&embedded=true';
                      return (
                        <iframe
                          src={gViewerUrl}
                          width="100%"
                          height="400px"
                          frameBorder="0"
                          title={file.saved_name}
                        />
                      );
                    }

                    return (
                      <a
                        href={url}
                        download
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          textDecoration: 'none',
                        }}
                      >
                        <InsertDriveFileIcon style={{ marginRight: 4 }} />
                        {file.saved_name}
                      </a>
                    );
                  },
                }]}
                data={item.Answers}
              />
            </>
          )}
        </Box>
      ))}
    </section>
  );
}

ActionOffers.propTypes = {
  actionId: PropTypes.any,
  getUserIndividualAnswers: PropTypes.func,
  userAnswers: PropTypes.shape({
    list: PropTypes.shape({
      map: PropTypes.func,
    }),
    loading: PropTypes.any,
  }),
  userId: PropTypes.any,
};

const mapStateToProps = (state) => {
  return {
    userAnswers: state.userAnswers,
    auth: state.auth,
    general: state.general,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getUserIndividualAnswers }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ActionOffers);
